import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Modal, Form, Button, Icon } from "semantic-ui-react";
import { insert_linktree } from "../../utils/requestHelper";

function removeEmptyStrings(obj) {
  let newObj = {};
  Object.keys(obj).forEach((prop) => {
    if (obj[prop] !== null && obj[prop] !== "" && obj[prop] !== undefined) {
      newObj[prop] = obj[prop];
    }
    if (obj[prop] === 0) {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
}

const NewLinktree = ({ hide, locations = [] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState({
    type: "custom",
    title: "",
    subtitle: "",
    slug: "",
    locationId: null,
    isActive: 0,
  });
  const [errors, setErrors] = useState({});

  const handleOnChange = (e) => {
    const { id, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleTypeChange = (_, { value }) => {
    setData((prev) => {
      if (value === "custom") {
        return {
          ...prev,
          type: "custom",
          locationId: null,
          slug: "",
        };
      }

      return {
        ...prev,
        type: "location",
        slug: "",
      };
    });
  };

  const handleLocationChange = (_, { value }) => {
    const location = locations.find(l => l.id === value);

    setData((prev) => ({
      ...prev,
      locationId: value,
      slug: location ? location.slug : "",
    }));
  };

  const handleOnSubmit = async () => {
    if (data) {
      let obj = removeEmptyStrings(data);
      let newErrors = {};
      let error = false;
      
      if (!obj.title) {
        newErrors.titleError = t("input-error-title");
        error = true;
      }

      if (obj.type === "custom" && !obj.slug) {
        newErrors.slugError = t("input-error-slug");
        error = true;
      }

      if (obj.type === "location" && !obj.locationId) {
        newErrors.locationError = t("input-error-location");
        error = true;
      }

      setErrors({
        ...newErrors,
      });
      if (error === false) {
        const result = await insert_linktree(data);
        if (result.success === true) {
          hide();
        }
        navigate(`/linktrees`);
      }
    }
  };

  return (
    <>
      <Modal.Header>{t(`headline-new_linktree`)}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.Input
              id="title"
              error={
                errors.hasOwnProperty("titleError") && {
                  content: errors.titleError,
                }
              }
              onChange={handleOnChange}
              required
              label={t(`input-label-title`)}
              placeholder={t(`input-placeholder-title`)}
            />
            <Form.Input
              id="subtitle"
              error={
                errors.hasOwnProperty("subtitleError") && {
                  content: errors.subtitleError,
                }
              }
              onChange={handleOnChange}
              required
              label={t(`input-label-subtitle`)}
              placeholder={t(`input-placeholder-subtitle`)}
            />
            <Form.Select
              label={t("input-label-type")}
              options={[
                { key: "location", value: "location", text: t("type-location") },
                { key: "custom", value: "custom", text: t("type-custom") },
              ]}
              value={data.type}
              onChange={handleTypeChange}
            />
            {data.type === "location" && (
              <Form.Select
                label={t("input-label-location")}
                options={locations.map(l => ({
                  key: l.id,
                  value: l.id,
                  text: l.name,
                }))}
                value={data.locationId}
                onChange={handleLocationChange}
                required
              />
            )}
            {data.type === "custom" && (
            <Form.Input
              id="slug"
              value={data.slug}
              readOnly={data.type === "location"}
              required={data.type === "custom"}
              onChange={handleOnChange}
              label={t("input-label-slug")}
            />
            )}
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={hide}>
          <Icon name="times" />
          {t(`button-cancel`)}
        </Button>
        <Button onClick={handleOnSubmit} primary>
          <Icon name="check" />
          {t(`button-create`)}
        </Button>
      </Modal.Actions>
    </>
  );
};

export default NewLinktree;
